import { PopulationFilter } from '@digital-twins/shared-types'

/**
 * Structured twin-test segment on `POST /workflow-runs`. Sibling of `inputs`,
 * never serialized into `rest` or any text input.
 */
export interface WorkflowRunSegmentFields {
  populationFilter?: PopulationFilter
  segmentLabel?: string
}

/**
 * Copy structured seed fields onto the start-run body. Absent / blank =
 * today's full-audience create payload (those keys omitted).
 */
export function workflowRunSegmentFields(
  seed: WorkflowRunSegmentFields | null | undefined,
): WorkflowRunSegmentFields {
  if (!seed) {
    return {}
  }

  const next: WorkflowRunSegmentFields = {}
  if (seed.populationFilter) {
    next.populationFilter = seed.populationFilter
  }
  const segmentLabel =
    typeof seed.segmentLabel === 'string' ? seed.segmentLabel.trim() : ''
  if (segmentLabel) {
    next.segmentLabel = segmentLabel
  }
  return next
}

export function workflowRunSegmentFieldsForSlug(
  seed: (WorkflowRunSegmentFields & { slug?: string }) | null | undefined,
  slug: string,
): WorkflowRunSegmentFields {
  if (!seed?.slug || seed.slug !== slug) {
    return {}
  }
  return workflowRunSegmentFields(seed)
}
